import React, { useState } from "react";
import Homepage_Data from "../utils/HomepageData";
import down_img from "../assets/images/Arrow_down.svg";
const Accordion = ({ classes }) => {
  const { faqQuestion } = Homepage_Data;
  const [activeIndex, setActiveIndex] = useState(null);

  const handleSmoothScroll = (event) => {
    event.preventDefault(); // Prevent default anchor behavior
    const target = document.querySelector("#currencyForm"); // Get the target element
    if (target) {
      target.scrollIntoView({
        behavior: "smooth", // Enable smooth scrolling
        block: "start", // Align to the top of the target element
      });
    }
    // if (onClick) {
    //   onClick(event); // Call the provided onClick handler if it exists
    // }
  };

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className={`${classes} lg:max-w-7xl lg:mx-auto px-5 md:px-0`}>
      <div className="mb-[20px] mx-[20px]">
        <h2 className="text-[24px] sm:text-[36px] lg:text-[40px] font-bold">
          Frequently Asked Questions (FAQs) –
        </h2>
        <h2 className="text-[16px] sm:text-[20px] lg:text-[24px] text-[#2C2C2C] font-bold ">
          Get clear and reliable information to help you make informed
          decisions.
        </h2>
      </div>
      <div className="bg-[#6c33b50e] w-full sm:py-[20px] sm:px-[10px] flex items-center ">
        <div className="w-full">
          {faqQuestion.map((item, index) => (
            <div key={item.id} className="  my-1 md:my-3 rounded-lg ">
              <button
                onClick={() => handleToggle(index)}
                className="w-full text-left px-4 py-0 md:py-2 text-2xl flex justify-between items-center font-semibold sm:mb-[20px]"
              >
                <span className="text-[14px] text-[#2C2C2C] sm:text-sm md:text-[20px] space-y-0">
                  {item.title}
                </span>
                <span className="text-[14px]">
                  {activeIndex === index ? (
                    <img
                      className="transform rotate-180"
                      src={down_img}
                      alt="/down_img"
                    />
                  ) : (
                    <img src={down_img} alt="/down-img" />
                  )}
                </span>
              </button>
              {activeIndex === index && (
                <div
                  className="text-[12px] px-4 py-2 tracking-wide sm:text-[16px] sm:text-[#888888] sm:font-[500]"
                  dangerouslySetInnerHTML={{ __html: item.content }}
                />
              )}
              <hr className="w-[90%] m-auto" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
